import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import * as day from 'dayjs';
import {
  EntityType,
  ResponseMessageStatus,
  ResponseStatus,
  SortBy,
  StockLocation,
} from 'src/app/shared/enums';
import moment from 'moment';
import { CommonService } from 'src/app/services/common.service';
import { DatePipe } from '@angular/common';
import { BadeLoftService } from '../bade-loft.service';


@Component({
  selector: 'app-shipped',
  templateUrl: './shipped.component.html',
  styleUrls: ['./shipped.component.css']
})
export class ShippedComponent implements OnInit {

  //#region Variables/Properties
  setOfCheckedIdAccountData = new Set<number>();
  lst_Status: any = [];
  stockLocation: typeof StockLocation;
  sortField: string = 'createddate';
  sortBy: number = SortBy.Dsc;
  page: number = 1;
  pageSize: number = 100;
  totalRecord: number = 0;
  searchText: string = '';
  oldSearchText: string = '';
  timer: any = null;
  isStatusLoaded: boolean = false;
  isAuditVisible: boolean = false;
  entityDetails: any;
  entityType: number = EntityType.Status;
  statusMaxPageSize: number = 0;
  checkedAccountData = false;
  indeterminateAccountData = false;
  //setOfCheckedIdAccountData = new Set<number>();
  isShowChangeShipDate: boolean = false;
  shipDate: Date = new Date();
  bl_Status: string = '';
  statusList_Request: any;
  filterDate: any = [];
  popConfirmVisible: boolean = false;
  shippedCompleted = false;
  setOfCheckedId = new Set<number>();
  selected: { startDate: Date; endDate: Date };
  ranges: any = {
    Today: [day(), day()],
    Yesterday: [day().subtract(1, 'days'), day().subtract(1, 'days')],
    Tomorrow: [day().add(1, 'days'), day().add(1, 'days')],
    'Last 7 Days': [day().subtract(6, 'days'), day()],
    'Last 30 Days': [day().subtract(29, 'days'), day()],
    'This Month': [day().startOf('month'), day().endOf('month')],
    'Last Month': [
      day().subtract(1, 'month').startOf('month'),
      day().subtract(1, 'month').endOf('month'),
    ],
    'Last 3 Months': [
      moment().subtract(90, 'days'),
      moment(),
    ],
  };
  isAssignmentVisible: boolean = false;
  editAssignmentDetail: any = null;
  stockAssignmentDetail: any = null;
  currentStatus: any = 1;
  incompleteStatusCount: any = 0;
  incompleteStatusList_Request: any = null;

  currentCompletingId: any;
  currentInvoiceAmount: number = 0;
  userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');

  //#region Variables/Properties

  constructor(
    private _shippedService: BadeLoftService,

    public _cS: CommonService,
    private _datepipe: DatePipe,
  ) { }

  ngOnInit(): void {
    const startDate = moment().subtract(90, 'days').startOf('day');
    const endDate = moment().endOf('day');

    this.selected = { startDate: startDate.toDate(), endDate: endDate.toDate() };
    this.filterDate = [
      startDate.utc().format(),
      endDate.utc().format()
    ];

    this.getShippedData();
  }

  getShippedData() {
    if (!this.filterDate) {
      this.selected = {
        startDate: this.ranges['Last 3 Months'][0],
        endDate: this.ranges['Last 3 Months'][1],
      };
      this.filterDate[0] = moment().set({ hour: 0, minute: 0, second: 0 }).utc().format();
      this.filterDate[1] = moment().set({ hour: 0, minute: 0, second: 0 }).utc().format();
    }
    try {
      this._shippedService.GetShippedData(
        this.searchText.trim(),
        this.sortField,
        this.sortBy,
        this.filterDate[0],
        this.filterDate[1],
      )
        .subscribe((res) => {
          if (res) {
            if (res.responseStatus == ResponseStatus.Success) {
              var data = res.result.records;
              this.totalRecord = res.result.totalRecord;
              this.statusMaxPageSize = res.result.totalPage;
              // Clear the list before adding new data
              this.lst_Status = [];
              if (data && data.length > 0) {
                data.forEach((x: any) => {
                  this.lst_Status.push(x);
                });
              }
              this.lst_Status.map((x: any) => {
                x.expand = false;
              });
            } else {
              this._cS.displayMessage(ResponseMessageStatus.error, res.message);
            }
            var local_data = {
              searchText: this.searchText,
              sortBy: this.sortBy,
              sortField: this.sortField,
            };
            this._cS.setLocalStorageItem(
              'status_data',
              JSON.stringify(local_data)
            );
          }
          this.isStatusLoaded = false;
        });
    } catch (error) { }
  }

  onDateChange(result: any) {
    if (result.startDate == null) {
      let todayDate = new Date();
      todayDate.setHours(0, 0, 0);
      this.filterDate[0] = this._datepipe.transform(todayDate, 'yyyy-MM-dd') + 'T00:00:00Z';
      this.filterDate[1] = this._datepipe.transform(todayDate, 'yyyy-MM-dd') + 'T23:59:59Z';
    } else {
      this.filterDate[0] = result?.startDate?.utc().format();
      this.filterDate[1] = result?.endDate?.utc().format();
    }
    if (this.currentStatus == 1) {
      this.getShippedData();
    }
  }

  sort(key: string) {
    if (key) {
      this.sortBy = this.sortBy == SortBy.Asc ? SortBy.Dsc : SortBy.Asc;
      this.sortField = key;
      if (this.statusList_Request) this.statusList_Request.unsubscribe();
      if (this.currentStatus == 1) {
        this.getShippedData();
      }
    }
  }




  // "Sync from AfterShip" modal — here it mostly runs Delivered: once In Transit has consumed the
  // stock the order leaves the Status page, so this is the only screen that still lists it.
  afterShipOrder: any = null;
  showAfterShipSync(data: any) {
    if (data?.qB_TrackingNo && !this.isDelivered(data)) this.afterShipOrder = data;
  }

  // Delivered is the last AfterShip step — nothing left to sync, so the icon is hidden (client 2026-09-10).
  // Shipped page only: on the Status page a Delivered row still has unconsumed stock and needs In Transit.
  isDelivered(data: any): boolean {
    return (data?.qB_BL_Status || '').trim().toLowerCase() === 'delivered';
  }

  hideAfterShipSync(event: any) {
    this.afterShipOrder = null;
    if (event?.synced) this.getShippedData();
  }

  UpdateShippedReturnStatus(data: any, status: boolean = true) {
    let todayDate = new Date();

    const returnAssignment = {
      assignmentId: data.id,
      invoiceNo: data.invoiceNo,
      returnRequestDate: this._datepipe.transform(todayDate, 'yyyy-MM-ddTHH:mm:ss\'Z\''),
      returnTrackingNo: "",
      isBackToStock: 'false',
      isDamaged: 'false'
    };
    this._shippedService.UpdateShippedReturnStatus(returnAssignment, status)
      .subscribe((res) => {
        if (res) {
          if (res.responseStatus == ResponseStatus.Success) {
            this._cS.displayMessage(ResponseMessageStatus.success, res.message);
            this.getShippedData();
          } else {
            this._cS.displayMessage(ResponseMessageStatus.error, res.message);
          }
        }
      });
  }

}